<template>
  <div  class="content gvideo" >
      <div v-if="!showIframe" @click.stop.prevent="showIframe = true" :style="styleObject" />
      <div v-if="showIframe" class="iframe-wrapper" :style="paddingBottom">
        <iframe :src="'https://drive.google.com/file/d/'+gFile.id+'/preview'"></iframe>
      </div>
    </div>
</template>

<script>
export default {
  name: 'GFileVideo',
  props: {
    gFile: Object,
    gBaseUrl: String
  },
  data () {
    return {
      showIframe: false
    }
  },
  computed: {
    styleObject () {
      return {
        ...{
          background: ' white url(' + this.gBaseUrl + '/thumbnail?export=view&sz=w1140&id=' + this.gFile.id + ')',
          backgroundSize: 'cover'
        },
        ...this.paddingBottom
      }
    },
    paddingBottom () {
      if (this.gFile.videoMediaMetadata && this.gFile.videoMediaMetadata.height && this.gFile.videoMediaMetadata.width) {
        return { 'padding-bottom': (this.gFile.videoMediaMetadata.height / this.gFile.videoMediaMetadata.width * 100) + '%' }
      } else {
        return {}
      }
    }
  }
}
</script>
